export default "__VITE_ASSET__B8k5hvAO__$_?no-inline__"